import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { baseUrl } from "../../../../../../../../network/constants/constants";

const ViewPageService = ({
  open,
  onClose,
  currentRequest,
  newRequest,
  status,
  currentId,
  handleAdminResponse
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: "20px" },
      }}
    >
      <DialogTitle className="request-head">Request Details</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography variant="h6">
            Status: <span className="status-span">{status}</span>
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="request-subhead">Field</TableCell>
                <TableCell className="request-subhead">Old Value</TableCell>
                <TableCell className="request-subhead">Edited Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className="subhead">Service Name</TableCell>
                <TableCell>
                  {currentRequest?.serviceName || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.serviceName || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Category Name</TableCell>
                <TableCell>
                  {currentRequest?.categoryName || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.categoryName || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Description</TableCell>
                <TableCell>
                  {currentRequest?.description || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.description || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Terms and Conditions</TableCell>
                <TableCell>
                  {currentRequest?.terms_and_condition || (
                    <Typography>N/A</Typography>
                  )}
                </TableCell>
                <TableCell>
                  {newRequest?.terms_and_condition || (
                    <Typography>N/A</Typography>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Open Time</TableCell>
                <TableCell>
                  {currentRequest?.openTime || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.openTime || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Close Time</TableCell>
                <TableCell>
                  {currentRequest?.closeTime || <Typography>N/A</Typography>}
                </TableCell>
                <TableCell>
                  {newRequest?.closeTime || <Typography>N/A</Typography>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="subhead">Thumb</TableCell>
                <TableCell>
                  {currentRequest?.thumb ? (
                    <img
                      src={`${baseUrl}${currentRequest?.thumb}`}
                      alt="Current Icon"
                      style={{ width: 50, height: 50, objectFit: "contain" }}
                    />
                  ) : (
                    <Typography color="textSecondary">N/A</Typography>
                  )}
                </TableCell>
                <TableCell>
                  {newRequest?.thumb ? (
                    <img
                      src={`${baseUrl}${newRequest?.thumb}`}
                      alt="New Icon"
                      style={{ width: 50, height: 50, objectFit: "contain" }}
                    />
                  ) : (
                    <Typography color="textSecondary">N/A</Typography>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <DialogActions>
          <Button
            onClick={onClose}
            variant="contained"
            color="error"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          {status === "Pending" && (
            <>
          <Button
            variant="outlined"
            color="success"
            style={{ marginRight: "5px" }}
            onClick={() => {
              handleAdminResponse(currentId, "accept");
              onClose();
            }}
          >
            Accept
          </Button>
          <Button
            variant="outlined"
            color="error"
            style={{ marginRight: "5px" }}
            onClick={() => {
              handleAdminResponse(currentId, "reject");
              onClose();
            }}
          >
            Reject
          </Button>
          </>
          )}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ViewPageService;
